function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 2.25A2.25 2.25 0 0 1 8.75 0h4.5a2.25 2.25 0 0 1 2.25 2.25V3h5.25a.75.75 0 0 1 0 1.5H1.25a.75.75 0 0 1 0-1.5H6.5v-.75zm7.5 0V3H8v-.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.497 6.682a.75.75 0 1 0-1.494.136l1.438 15.818A1.5 1.5 0 0 0 4.935 24h12.13a1.5 1.5 0 0 0 1.494-1.364l1.438-15.818a.75.75 0 1 0-1.494-.136L17.065 22.5H4.935L3.497 6.682z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8.25V19.5H8V8.25h1.5zM14 19.5V8.25h-1.5V19.5H14z"
});

var SvgTrashSmall = function SvgTrashSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "4cae5241e85097fe652f8ba070fa9001.svg";
export { SvgTrashSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/trash-small.svg
// module id = null
// module chunks = 